module.exports = __webpack_public_path__ + "static/media/garden.6f817f1b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/features/garden.svg
// module id = 1519
// module chunks = 0